export default __webpack_public_path__ + "static/media/star-fill.e58546d8.svg";